import { render, staticRenderFns } from "./points-of-sale.vue?vue&type=template&id=9a70654e"
import script from "./points-of-sale.vue?vue&type=script&lang=js"
export * from "./points-of-sale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports